import api from './axios';
import { ApiResponse } from '../types';
import { User } from '../types';

export type ManualPaymentPayload = {
  phone: string;
  payment_method: 'bKash' | 'Nagad' | 'Rocket' | 'Dutch Bangla Bank';
  transaction_id: string;
};

export type PaymentResponse = {
  status: string;
  token?: string;
  user?: User;
};

export const submitManualPayment = async (payload: ManualPaymentPayload) => {
  const response = await api.post<ApiResponse<PaymentResponse>>('/api/v1/payments/manual', payload);
  return response.data;
};
